module.exports = __webpack_public_path__ + "static/media/EE100.b615fb4e.PNG";